import { render, staticRenderFns } from "./ParticaView.vue?vue&type=template&id=a615f1aa&scoped=true&"
import script from "./ParticaView.vue?vue&type=script&lang=ts&"
export * from "./ParticaView.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaView.vue?vue&type=style&index=0&id=a615f1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a615f1aa",
  null
  
)

export default component.exports